import dayjs from 'dayjs'
import { ArtworkDBType, ArtworkStatusEnum } from '~/graphqls/types'

export const chunkDataAsTimeTarget = (arr: any, target: string) => {
  const len = arr.length
  if (len <= 1) return [arr]
  let data = []
  let child = [arr[0]]
  let dayFormat = dayjs(arr[0][target] * 1000).format('YYYY-MM')
  for (let i = 1; i < len; i++) {
    if (dayFormat === dayjs(arr[i][target] * 1000).format('YYYY-MM')) {
      child.push(arr[i])
    } else {
      data.push(child)
      dayFormat = dayjs(arr[i][target] * 1000).format('YYYY-MM')
      child = [arr[i]]
    }
    if (i === len - 1) {
      data.push(child)
    }
  }
  return data
}

export const getGraphData = <T = any>(data: any[]) => {
  if (!data?.length) return []

  let newData: T[] = []
  data.forEach(item => {
    newData.push(item.node)
  })
  return newData
}
export const getGraphDataWithCursor = (data: any[]) => {
  if (!data?.length) return []

  let newData: any[] = []
  data.forEach(item => {
    if (item.node) {
      item.node.cursor = item.cursor
    }
    newData.push(item.node)
  })
  return newData
}

// 去重
export function uniqueArray(
  prevArr: any[],
  appendArr: any[],
  fn?: (it: any) => any
) {
  if (!appendArr.length) return prevArr
  const ids = prevArr.map(item => {
    return fn ? fn(item) : item['id']
  })
  return [
    ...prevArr,
    ...appendArr.filter(item => {
      return !ids.includes(fn ? fn(item) : item['id'])
    }),
  ]
}

export function uniqueArrayUnShift(
  prevArr: any[],
  appendArr: any[],
  fn?: (it: any) => any
) {
  if (!appendArr.length) return prevArr
  const ids = prevArr.map(item => {
    return fn ? fn(item) : item['id']
  })
  return [
    ...appendArr.filter(item => {
      return !ids.includes(fn ? fn(item) : item['id'])
    }),
    ...prevArr,
  ]
}

// 新的去重，似乎比上面的优雅
export function uniqueFunc(arr: any[], key: string) {
  const res = new Map()
  return arr.filter(item => !res.has(item[key]) && res.set(item[key], 1))
}

// 深拷贝
export const deepCopy = function (obj: any) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 自定义规则排序
 * @param sortArr 需要排序的数组
 * @param baseArr 按照什么顺序排序,不在baseArr里的字段会被过滤
 * @param fn 排序的字段
 */
export const sortBy = <T = any>(
  sortArr: T[],
  baseArr: any[],
  fn: (it: any) => any
) => {
  if (sortArr?.length <= 1) return sortArr
  return sortArr
    .sort((a: T, b: T) => baseArr.indexOf(fn(a)) - baseArr.indexOf(fn(b)))
    ?.filter((it: T) => baseArr.includes(fn(it)))
}

/**
 *
 * @param data 需要分组的数组
 * @param fn 排序的字段
 * @returns 二位数组
 */
export const groupListById = (data: any[], fn: (it: any) => any) => {
  const groups: any = new Map()
  data.forEach(it => {
    const groupId = fn(it)
    groups.set(groupId, groups.get(groupId) || [])
    groups.get(groupId).push(it)
  })
  return [...groups.values()]
}

export const getArtworkCopyRightStatus = (item: any) => {
  const result = {
    /** 已上架版权市场 */
    copyRightAccept: false,
    /** 上架版权市场审核中 */
    copyRightWait: false,
    /** 是否可以使用 */
    copyRightDisabled: false,
  }
  if (!item) {
    return result
  }
  // 已上架版权市场
  result.copyRightAccept =
    item.extend?.copyrightArtwork?.type === ArtworkDBType.AI_COPYRIGHT &&
    item.extend?.copyrightArtwork?.status === ArtworkStatusEnum.ACCEPT
  // 上架版权市场审核中
  result.copyRightWait =
    item.extend?.copyrightArtwork?.type === ArtworkDBType.AI_COPYRIGHT &&
    item.extend?.copyrightArtwork?.status === ArtworkStatusEnum.WAIT

  result.copyRightDisabled = result.copyRightAccept || result.copyRightWait
  return result
}

/** 判断 a 是否是 null 或者 undefined, 排除 a 为 0 的情况 */
export function isNullOrUndefined(a: any): Boolean {
  if (a === null) {
    return true
  }
  if (a === undefined) {
    return true
  }

  return false
}
